module.exports = __webpack_public_path__ + "img/logo.32d8cbc5.svg";